import axios from 'axios';
import type { CreateAxiosDefaults, AxiosInstance } from 'axios';
import { applyTokenRefreshInterceptor } from './token-refresh/axios-interceptor';

/**
 * Creates an Axios instance with the token refresh interceptor applied.
 *
 * Use this instead of `axios.create()` for all isomorphic service clients.
 * The interceptor reads the non-httpOnly `refresh_at` cookie before every
 * request to detect missing or stale tokens. When tokens need refreshing,
 * all concurrent requests are gated behind a single shared call to
 * `/api/auth/refresh-tokens`, preventing SLAS rate-limit (409) errors.
 *
 * On the server side, the interceptor is inert — `needsRefresh()` returns
 * `false` in non-browser environments (see `axios-token-interceptor.ts`).
 * @param config - Optional Axios defaults (`baseURL`, `headers`, `timeout`, etc.).
 * @returns A new `AxiosInstance` with the token refresh request interceptor applied.
 */
export function createAPIClient(config?: CreateAxiosDefaults): AxiosInstance {
  const instance = axios.create(config);
  applyTokenRefreshInterceptor(instance);
  return instance;
}
